const AstonMartin = [
    {
        ID: "astonmartin_1",
        name: "DBS Superleggera",
        brand: "Aston Martin",
        price: 21,
        engine: "V12 5.2L",
        max: 340,
        version: "ZF 8",
        type: "Coupe",
        avatar: "https://i.ibb.co/R6Rr3bG/Aston-Martin-DBS.webp",
        link: "/brands/aston-martin/dbs-superleggera",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "astonmartin_2",
        name: "DB11",
        brand: "Aston Martin",
        price: 15,
        engine: "V8 4.0L",
        max: 301,
        version: "ZF 8",
        type: "Coupe",
        avatar: "https://i.ibb.co/mGPpyhk/DB11.webp",
        link: "/brands/aston-martin/db11",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "astonmartin_3",
        name: "Vanquish",
        brand: "Aston Martin",
        price: 19.5,
        engine: "V12 6.0L",
        max: 324,
        version: "8 AT",
        type: "Coupe",
        avatar: "https://i.ibb.co/svDqf35/Vanquish.webp",
        link: "/brands/aston-martin/vanquish",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "astonmartin_4",
        name: "One 77",
        brand: "Aston Martin",
        price: 70.3,
        engine: "V12 7.3L",
        max: 354,
        version: "6 AT",
        type: "Coupe",
        avatar: "https://i.ibb.co/MNyX1RR/one-1.webp",
        link: "/brands/aston-martin/one-77",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "astonmartin_5",
        name: "Rapide",
        brand: "Aston Martin",
        price: 4.8,
        engine: "V12 6.0L",
        max: 295,
        version: "8 ZF",
        type: "Coupe 4",
        avatar: "https://i.ibb.co/sj66LXK/rapid-webp.webp",
        link: "/brands/aston-martin/rapide",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "astonmartin_6",
        name: "Rapide S",
        brand: "Aston Martin",
        price: 9.2,
        engine: "V12 6.0L",
        max: 326,
        version: "8 AT",
        type: "Coupe 4",
        avatar: "https://i.ibb.co/mDRXcM3/rps-1.webp",
        link: "/brands/aston-martin/rapide-s",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "astonmartin_7",
        name: "Rapide AMR",
        brand: "Aston Martin",
        price: 5.6,
        engine: "V12 6.0L",
        max: 330,
        version: "8 AT",
        type: "Coupe 4",
        avatar: "https://i.ibb.co/0Q7VdHp/rappid-awm.webp",
        link: "/brands/aston-martin/rapide-amr",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "astonmartin_8",
        name: "DB 9",
        brand: "Aston Martin",
        price: 17.9,
        engine: "V12 6.0L",
        max: 295,
        version: "ZF 6",
        type: "Coupe 4",
        avatar: "https://i.ibb.co/JKHH2KQ/db9.webp",
        link: "/brands/aston-martin/db9",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "astonmartin_9",
        name: "DB 9 Volante",
        brand: "Aston Martin",
        price: 21.7,
        engine: "V12 6.0L",
        max: 299,
        version: "6 AT",
        type: "Coupe 4",
        avatar: "https://i.ibb.co/n6ntxYf/db9-v.webp",
        link: "/brands/aston-martin/db9-volante",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "astonmartin_10",
        name: "AM-RB 003",
        brand: "Aston Martin",
        price: 25.8,
        engine: "V12 6.0L",
        max: 354,
        version: "8 DCT",
        type: "Coupe",
        avatar: "https://i.ibb.co/4KqvZW3/AM-RB003.webp",
        link: "/brands/aston-martin/amrb-003",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "astonmartin_11",
        name: "Valkyrie",
        brand: "Aston Martin",
        price: 70.3,
        engine: "V12 6.5L",
        max: 353,
        version: "7",
        type: "Coupe",
        avatar: "https://i.ibb.co/7X0vRYF/Valkyrie.webp",
        link: "/brands/aston-martin/valkyrie",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
];
export default AstonMartin;
